<app-modal *ngIf="vo$ | async; let vo">
	<div modal-body class="app-ranking-action-popup">
		<div class="app-ranking-action-popup__element">
			<ng-container *ngIf="!vo.isMultipleElement">
				<span i18n="@@ranking.action.popup.concernedElement">
					concerned Element
				</span>
				<span class="app-ranking-action-popup__element-label">
					{{ vo.element }}
				</span>
			</ng-container>
			<ng-container *ngIf="vo.isMultipleElement">
				<span i18n="@@ranking.action.popup.concernedElements">
					concerned Elements
				</span>
				<div class="app-ranking-action-popup__element-label">
					{{ vo.rankingId.length }}
					<span i18n="@@ranking.action.popup.rankings">rankings</span>
				</div>
			</ng-container>
		</div>
		<ng-container [ngSwitch]="vo.action">
			<div
				*ngSwitchCase="RankingAction.Delete"
				class="app-ranking-action-popup__delete">
				<span
					*ngIf="vo.isMultipleElement"
					class="app-ranking-action-popup__description"
					i18n="@@ranking.action.popup.delete.multiple.description">
					deletion request
				</span>
				<span
					*ngIf="!vo.isMultipleElement"
					class="app-ranking-action-popup__description"
					i18n="@@ranking.action.popup.delete.description">
					deletion request
				</span>

				<div class="app-ranking-action-popup__delete-info">
					<mat-icon [svgIcon]="DcIcons.Warning"></mat-icon>
					<span
						*ngIf="vo.isMultipleElement"
						class="app-ranking-action-popup__message"
						i18n="@@ranking.action.popup.delete.multiple.info">
						deletion info
					</span>
					<span
						*ngIf="!vo.isMultipleElement"
						class="app-ranking-action-popup__message"
						i18n="@@ranking.action.popup.delete.info">
						deletion info
					</span>
				</div>
				<div class="app-ranking-action-popup__checkbox">
					<mat-checkbox
						id="{{ cmpId }}-confirm-checkbox"
						color="primary"
						[(ngModel)]="confirmDeletion">
							<span i18n="@@ranking.action.popup.delete.confirm">confirm delete</span>
					</mat-checkbox>
				</div>
			</div>
			<div *ngSwitchCase="RankingAction.Duplicate">
				<span
					class="app-ranking-action-popup__description"
					i18n="@@ranking.action.popup.duplicate.description">
					duplicate
				</span>
			</div>
		</ng-container>
	</div>

	<div modal-footer class="app-ranking-action-popup__footer">
		<ng-container [ngSwitch]="vo.action">
			<button
				*ngSwitchCase="RankingAction.Delete"
				id="{{ cmpId }}-delete-btn"
				class="app-ranking-action-popup__footer__btn"
				[color]="'warn'"
				[disabled]="!confirmDeletion"
				(click)="confirmAction()"
				mat-raised-button>
				<mat-icon [svgIcon]="DcIcons.Delete"></mat-icon>
				<span i18n="@@ranking.action.popup.delete.btn">delete</span>
			</button>
			<button
				*ngSwitchCase="RankingAction.Duplicate"
				id="{{ cmpId }}-duplicate-btn"
				class="app-ranking-action-popup__footer__btn"
				(click)="confirmAction()"
				mat-raised-button>
				<span i18n="@@ranking.action.popup.duplicate.btn">duplicate</span>
			</button>
		</ng-container>
	</div>
</app-modal>
